import React from 'react';
import { Box } from '@chakra-ui/react';

const PageContainer: React.FC = ({ children }) => {
  return <Box p="25px">{children}</Box>;
};

export default PageContainer;
